var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhilanthropy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9869 2.97406L7.33354 5.46739C5.8002 6.04072 4.54688 7.85404 4.54688 9.49404V19.4007C4.54688 20.974 5.58689 23.0407 6.85356 23.9874L12.5869 28.2674C14.4669 29.6807 17.5602 29.6807 19.4402 28.2674L25.1735 23.9874C26.4402 23.0407 27.4802 20.974 27.4802 19.4007V9.49404C27.4802 7.85404 26.2269 6.04072 24.6935 5.46739L18.0402 2.97406C16.9069 2.56073 15.0935 2.56073 13.9869 2.97406Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0009 14.5605C15.9476 14.5605 15.8809 14.5605 15.8276 14.5605C14.5742 14.5205 13.5742 13.4805 13.5742 12.2139C13.5742 10.9205 14.6276 9.86719 15.9209 9.86719C17.2142 9.86719 18.2676 10.9205 18.2676 12.2139C18.2542 13.4939 17.2542 14.5205 16.0009 14.5605Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3467 18.2945C12.0667 19.1478 12.0667 20.5478 13.3467 21.4011C14.8001 22.3744 17.1867 22.3744 18.6401 21.4011C19.9201 20.5478 19.9201 19.1478 18.6401 18.2945C17.2001 17.3211 14.8134 17.3211 13.3467 18.2945Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhilanthropy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/philanthropy.29d58da4.svg";
export { ForwardRef as ReactComponent };